module.exports={
  "parents": [
    {
      "nodeModule": "@mediatool/mt-frontend",
      "configFile": "./amend/common.json"
    },
    {
      "nodeModule": "@mediatool/mt-frontend",
      "configFile": "./amend/future-base.json"
    },
    {
      "nodeModule": "@mediatool/mt-utils",
      "configFile": "./amend/web.json"
    }
  ],
  "modules": {
    "LoginAdmin": "./web/login-app.jsx",
    "AdminLogin": "./web/admin-login.jsx",
    "messageCenter": {
      "require": "./web/message-center",
      "type": "value"
    }
  }
}
